// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"511c8c1a","725":"bb30727f","809":"af811f15"}[chunkId] + ".chunk.js";
};